import React, { useState } from 'react';
import { Container, Row, Col, Carousel, Table } from 'react-bootstrap';
import dummyImg from '../images/dummy-image.jpg';
import '../css/style.css';

const ProductDetailPage = ({ product }) => { // Receive the 'product' prop
    
  const productDetail = {
    name: product.title,
    brand: 'UltraShield™',
    madeIn: 'USA',
    material: 'Premium, latex-free',
    productID: product.id.toString(),
    description: `Precision, Comfort, Protection.
Designed for healthcare professionals who demand the highest standards, UltraShield™ Surgical Gloves deliver unparalleled protection and dexterity during critical procedures. Crafted from premium, latex-free material, they are:

Sterile and Powder-Free: Ensuring patient and practitioner safety.
Superior Fit and Sensitivity: Providing the tactile precision needed for complex surgeries.
Durable and Tear-Resistant: Reliable performance even in challenging conditions.

Available in sizes Small, Medium, Large, and Extra-Large. Take your care to the next level with ${'Brand'} because every detail matters.`,
    imageUrls: [dummyImg, dummyImg, dummyImg], // Replace with actual image URLs
  };

  const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const handleBack = () => {
        window.history.back();
    }

    // Ensure product data exists before rendering
    if (!productDetail) {
        return <div>Loading product details...</div>; // Or handle the loading state appropriately
    }

    return (
        <Container className="my-5">
            <button type="button" className="btn btn-link text-decoration-none text-black mb-4" onClick={handleBack}>
                &larr; Back
            </button>
            <Row>
                <Col md={6} className='mb-4'>
                    <Carousel activeIndex={index} onSelect={handleSelect}>
                        {productDetail.imageUrls ? (
                            productDetail.imageUrls.map((url, idx) => (
                                <Carousel.Item key={idx}>
                                    <img className="d-block w-100 rounded-0" src={url} alt={`Product Image ${idx + 1}`} style={{ maxHeight: '400px', objectFit: 'contain' }} />
                                </Carousel.Item>
                            ))
                        ) : (
                            <Carousel.Item>
                                <img className="d-block w-100 rounded-0" src={dummyImg} alt="Placeholder Image" style={{ maxHeight: '400px', objectFit: 'contain' }} />
                            </Carousel.Item>
                        )}
                    </Carousel>
                </Col>
                <Col md={6}>
                    <h2 className="mb-2">{productDetail.name}</h2>
                    <Table className='table-success table-borderless'>
                        <tbody>
                            <tr className="mb-1">
                                <th className="fw-bold">Brand:</th>
                                <td className="text-end">{productDetail.brand}</td>
                            </tr>
                            <tr className="mb-1">
                                <th className="fw-bold">Made In:</th>
                                <td className="text-end">{productDetail.madeIn}</td>
                            </tr>
                            <tr className="mb-1">
                                <th className="fw-bold">Material:</th>
                                <td className="text-end">{productDetail.material}</td>
                            </tr>
                            <tr className="mb-1">
                                <th className="fw-bold">Product ID:</th>
                                <td className="text-end">{productDetail.productID}</td>
                            </tr>
                            {/* Add more product details here if needed */}
                        </tbody>
                    </Table>
                    {/* Add any call-to-action buttons or further information here */}
                </Col>
            </Row>

            <div className="mt-4">
                <h3 className='bg-white round-0 p-1 mb-3 text-center' style={{ maxWidth: '300px' }}>Product Description</h3>
                <p className='bg-white round-0 px-2 pb-2 mb-2'>{productDetail.description}</p>
            </div>
        </Container>
    );
};

export default ProductDetailPage;